<template>
  <i
    class="source-dot"
    :style="color ? { '--source-color': color } : null"
  ></i>
</template>

<script>
export default {
  name: 'SourceDot',
  props: {
    color: { type: String, default: '' },
  },
}
</script>

<style scoped>
.source-dot {
  background: var(--source-color, #6b7280);
  border-radius: 50%;
  display: inline-block;
  flex: 0 0 auto;
  height: 9px;
  width: 9px;
}
</style>
